import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEyeOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1281 9.61703C14.0936 2.34982 5.90636 2.34991 1.87189 9.61712C1.74067 9.85348 1.74067 10.1466 1.87189 10.383C5.90637 17.6502 14.0936 17.6501 18.1281 10.3829C18.2593 10.1465 18.2593 9.85339 18.1281 9.61703Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgEyeOpen;
